const QUERY_KEY = {
  TEAM_DATA: "teamData",
  TEAM_LIST: "teamList",
  AUTH_INIT: "authInit",
  TEAM_WREATH_DEFAULT_INFO: "teamWreathDefaultInfo",
  TEAM_DISPOSAL_DEFAULT_INFO: "teamDisposalDefaultInfo",
  TEAM_SEND_HISTORY: "teamSendHistory",
  TEAM_ALL_SEND_HISTORY: "teamAllSendHistory",
  TEAM_HC_ALL_SEND_HISTORY: "teamHcAllSendHistory",
  TEAM_MAYFLOWER_ALL_SEND_HISTORY: "teamMayflowerAllSendHistory",
  TEAM_REGION_ALL_SEND_HISTORY: "teamRegionAllSendHistory",
  SANGJO_SERVICE: "sangjoService",
  WREATH_PRODUCTS: "wreath_products",
};

export default QUERY_KEY;
